export default () => {
  let loader = document.querySelector('.loader');
  let timeout = 600;

  if (window.location.pathname.toLowerCase() === "/projects/") {
    timeout = 1800;
  }

  if (loader) {
    setTimeout(function(){
      loader.classList.add('loader--hidden');
    }, timeout);
    setTimeout(function(){
      loader.remove();
    }, timeout+1000);
  }
}